import { Card } from './card.model';

export class TabDto {
  name: string;
  cards: Card[];

  constructor(name: string, cards: Card[]) {
    this.name = name;
    this.cards = cards;
  }
}
